$(document).ready(function(){

	// -- Hamburger --
	$('.hamburger').on('click', function(){
		$('body').toggleClass('mainMenu--open');
		$(this).toggleClass('is-active');
	});

	// -- Hamburger --
	$('.btn__quicklinksMenuFixed').on('click', function(){
		$('body').toggleClass('quicklinksMenuFixed--open');
	});

	$(window).on('resize orientationchange', function(){
		if ($(window).width() >= 1024) {
			$('body').removeClass('quicklinksMenuFixed--open');
		}
	});

});